var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-btn",
    { attrs: { flat: "", dense: "", size: "lg" } },
    [
      _c("flag", { attrs: { iso: _vm.nameLanguageSelected, size: "3rem" } }),
      _c(
        "q-popover",
        [
          _c(
            "q-list",
            {
              staticClass: "scroll",
              staticStyle: { "min-width": "100px" },
              attrs: { link: "", separator: "" }
            },
            _vm._l(_vm.languages, function(language, index) {
              return _c(
                "q-item",
                {
                  directives: [
                    { name: "close-overlay", rawName: "v-close-overlay" }
                  ],
                  key: index,
                  nativeOn: {
                    click: function($event) {
                      return _vm.changeIdiom(language.id)
                    }
                  }
                },
                [
                  _c("flag", {
                    staticStyle: { "margin-right": "3px" },
                    attrs: { iso: language.country_flag, size: "1.5rem" }
                  }),
                  _c("q-item-main", { attrs: { label: language.name } })
                ],
                1
              )
            }),
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }